<template>
  <div class="content">
    <div class="contentPrincipal">
      <div class="myContent">
      <div class="tabContent">
        <div class="tabElement contrat active" @click="changeTab('contrat')">
          <span class="material-icons-sharp"> system_update_alt </span>Stock
          actuel
        </div>
      </div>
</div>
      <div id="contratTab" class="tabElementContent active">
        <!-- <div @click="addNewContrat" class="buttonAdd">
              <span> Ajouter un contrat</span>
            </div> -->
            <div @click="makeStartParams" class="buttonAdd">
          <span> Paramètrages des trackings </span>
        </div>
        <span class="rubriqueTitle">
          {{
            manipulateData.valueStat ? manipulateData.valueStat : "Tracking"
          }}
          du
          {{
            manipulateData.startDate ? manipulateData.startDate : "--/--/---"
          }}
          au
          {{ manipulateData.endDate ? manipulateData.endDate : "--/--/---" }}
        </span>
        <div class="contentLists">
          <table class="contentListeTable">
            <thead>


              <tr v-if="manipulateData.valueStat == 'Tracking de BL'">
                <th v-for="item in tableHeaderBl" :key="item">{{ item }}</th>
              </tr>
              <tr v-else>
                <th  v-for="item in tableHeader" :key="item">{{ item }}</th>
              </tr>
            </thead>
            <img
              v-if="productBuyEstimation.length ==0"
              src="../assets/empty1.png"
              alt=""
            />
            <tbody v-if="manipulateData.valueStat == 'Tracking de produit'">
              <tr
                :class="item.isSelected === true ? 'active' : 'noActive'"
                v-for="item in productBuyEstimation"
                :key="item._id"
              >
                <td>{{ item.totalContainer ? item.totalContainer : 0 }}</td>
                <td>{{ item.tonsQuantity ? item.tonsQuantity : 0 }}</td>
                <td>{{ item.quantity ? item.quantity : 0 }}</td>
                <td>{{ item.cfaAmount ? item.cfaAmount : 0 }}</td>
                <td>{{ item.etdMonth ? item.etdMonth : 0 }}</td>
              </tr>
            </tbody>
            <tbody v-if="manipulateData.valueStat == 'Tracking de BL'">
              <tr
                :class="item.isSelected === true ? 'active' : 'noActive'"
                v-for="item in productBuyEstimation"
                :key="item._id"
              >
                <td>{{ item.transitaire  }}</td>
                <td>{{ item.dvt  }}</td>
                <td>{{ item.product  }}</td>
                <td>{{ item.totalContainer  }}</td>
                <td>{{ item.bl  }}</td>
                <td>{{ item.amountInCurrency  }}</td>
                <td>{{ item.shipName  }}</td>
                <td>{{ item.etdPol  }}</td>
                <td>{{ item.eta  }}</td>
                <td>{{ item.lastPosition  }}</td>
                <td>{{ item.ac  }}</td>
                <td>{{ item.avd  }}</td>

              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
    
    <script>
import { mapActions, mapGetters } from "vuex";
export default {
    props: {
    value: {
      type: Object, // Type de la valeur que vous attendez
      required: true, // Indique que cette prop est requise
    },
  },
  name: "estimationView",
  components: {},
  data: () => ({
    tableHeader: [
      "Total conteneur",
      "Quantité en tonne",
      "Quantité",
      "Montant FCFA",
      "Mois d'arrivée",
    ],
    tableHeaderBl: [
      "Transitaire",
      "DVT",
      "Produits",
      "Q",
      "BL",
      "Montant Facture",
      "Compagnie",
      "ETD",
      "ETA",
      "Dernière position",
      "AC",
      "AVD",
    ],
    isSelecteds: [],
    isSelectedAll: false,  
      manipulateData: {
      valueStat: "",
      startDate: "",
      endDate: "",
    },
  }),
  watch: {
    contenuerAllData() {
      this.isSelecteds = [];
    },
    value() {
      // alert("ok");
      this.manipulateData = Object.assign(
        {
          valueStat: "",
          startDate: "",
          endDate: "",
        },
        this.value
      );
    },
  },
  computed: {
    ...mapGetters([
      //   "globaleStockData",
      //   "blData",
      //   "conteneurData",
      //   "contenuerAllData",
      //   "storeData",
      "productBuyEstimation",
    ]),
  },
  async mounted() {
    // await this.getGlobaleStoreStock();
  },
  methods: {
    ...mapActions([
      //   "getContrat",
      //   "getSupplier",
      //   "getContratDetails",
      //   "getBl",
      //   "getConteneur",
      //   "getConteneurAll",
      //   "getTransitaire",
      //   "getStore",
      "getGlobaleStoreStock",
      "getStoreStock",
    ]),
    raccourcirTexte(texte) {
      return texte;
    },
    async makeStartParams() {
      this.$emit("show", true);
      const value = {
        modalType: "makeStartParams",
        valueStat:'Tracking de produit',
        startDate: this.manipulateData.startDate,
        endDate: this.manipulateData.endDate,
      };
      // await this.getProduct({});
      // await this.getStore({});
      // await this.getCustomerList({});
      //   alert(item);
      this.$emit("editeRowForDash", {
        name: "makeStartParams",
        size: 300,
        value: value,
      });
      this.$emit("show", false);
    },
    async addNewContratDetails(item) {
      this.$emit("show", true);
      if (!item.isSelected) {
        for (let i = 0; i < this.globaleStockData.length; i++) {
          this.globaleStockData[i].isSelected = false;
        }
        item.isSelected = true;
        console.log(this.globaleStockData);
        const value = {
          _id: item._id,
          modalType: "detailsStock",
         
          product: item.product ? item.product.name : "",
          productType: item.product ? item.product.type : "",
          quantity: item.quantity,
        };
        await this.getStoreStock({
          product: item.product ? item.product._id : "",
        });
        this.$emit("editeRowForDash", {
          name: "detailsStock",
          size: 1000,
          value: value,
        });
      } else {
        item.isSelected = false;
        this.$emit("closeAllModal");
      }
      this.$emit("show", false);
      // Forcer la mise à jour de la vue après modification de isSelected
      this.$forceUpdate();
    },
    async changeTab(tabName) {
      this.$emit("show", true);
      this.$emit("closeAllModal");
      if (tabName === "contrat") {
        await this.getContrat({});
      } else if (tabName === "bl") {
        await this.getBl({});
      } else if (tabName === "conteneur") {
        await this.getConteneurAll({ alreadyInStock: "Oui" });
      } else if (tabName === "conteneurWait") {
        await this.getConteneurAll({ alreadyInStock: "Non" });
      }
      // Masquer tous les onglets
      var tabContents = document.querySelectorAll(".tabElementContent");
      tabContents.forEach(function (tabContent) {
        tabContent.classList.remove("active");
      });

      // Afficher l'onglet sélectionné
      var selectedTab = document.getElementById(tabName + "Tab");
      selectedTab.classList.add("active");

      // Mettre à jour l'état actif des onglets de la barre de navigation
      var tabElements = document.querySelectorAll(".tabElement");
      tabElements.forEach(function (tabElement) {
        tabElement.classList.remove("active");
      });

      var selectedTabElement = document.querySelector(".tabElement." + tabName);
      selectedTabElement.classList.add("active");
      this.$emit("show", false);
    },
  },
};
</script>
    